// extracted by mini-css-extract-plugin
export var deleteModal = "_rw-0";